import { CONFLICT } from 'shared/contants';
import {
  isDocumentationChangedMeanwhileError,
  isLinkedDocumentationWithoutCurrentVersionError,
} from 'shared/utils/errorHandling';

/** Why the backend answered a documentation request with 409 (PT-7117). */
export enum DocumentationConflict {
  /** Someone else changed the documentation since it was read: the change is not saved. */
  changedMeanwhile = 'changedMeanwhile',
  /** A link to a documentation without a current version: there is nothing to open. */
  linkWithoutCurrentVersion = 'linkWithoutCurrentVersion',
}

export function isChangedMeanwhileConflict(conflict: DocumentationConflict | undefined): boolean {
  return conflict === DocumentationConflict.changedMeanwhile;
}

function hasConflictStatus(error: unknown): boolean {
  return typeof error === 'object' && error !== null && 'status' in error && error.status === CONFLICT;
}

/**
 * The kind of 409 of a documentation request; `undefined` for any other answer
 * and for a 409 it does not recognize (e.g. a version without a drawing),
 * which the default handling of a failed request keeps.
 */
export function classifyDocumentationConflict(error: unknown): DocumentationConflict | undefined {
  if (!hasConflictStatus(error)) {
    return undefined;
  }
  if (isLinkedDocumentationWithoutCurrentVersionError(error)) {
    return DocumentationConflict.linkWithoutCurrentVersion;
  }
  return isDocumentationChangedMeanwhileError(error) ? DocumentationConflict.changedMeanwhile : undefined;
}
